<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 18:20:30
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-20 15:20:59
 * @FilePath: \mrc-base-frontend\src\views\data-view\detail\index.vue
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <div>
      <mrc_ess_iconGroup
        :is_disabled="disabled"
        :showEdit="hasBtn('edit-view') && editPermission(params.org_level_uuid)"
        :show_del="
          hasBtn('delete-view') && editPermission(params.org_level_uuid)
        "
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>
      <data-info
        @success="success"
        @changeReadonly="changeReadonly"
        :paramsProps="params"
        :disabled="disabled"
        :loading="loading"
      ></data-info>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import {
  getViewTableInfo,
  addUpdateViewInfo,
  deleteTable,
} from "@/service/api/dataView";
import dataInfo from "../modules/index";
export default {
  components: { dataInfo },
  props: {},
  data() {
    return {
      loading: false,
      skeletonloading: true,
      params: {},
      disabled: false,
    };
  },
  validations: {},
  computed: {},
  created() {},
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_view";
          this.$store.commit("set_page_title", "label_edit_view");
        } else {
          this.$route.meta.title = "label_view_view";
          this.$store.commit("set_page_title", "label_view_view");
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (this.$store.state.iconstatus) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    await this.getInfo();
  },

  methods: {
    editPermission(uuid) {
      if (this.$store.state.userData.userType == 1) {
        if (uuid && uuid.length > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    async getInfo() {
      this.skeletonloading = true;
      const res = await getViewTableInfo({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        this.params = res.data;
      }
      this.skeletonloading = false;
    },
    async success(params, val2) {
      this.loading = true;
      try {
        const res = await addUpdateViewInfo({
          ...params,
          mrbase_sys_datamodel_field: val2,
        });
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_modification_was_successful"),
          });
          // this.$router.go(-1)
          this.disabled = !this.disabled;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    async changeReadonly() {
      this.handleEdit();
      await this.getInfo();
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 删除
    handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const del = await deleteTable({
            uuid: this.$store.state.uuid,
          });
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped></style>
